const TEXT_STYLE_MAP = {
  'questions_group': 'H2',
  'list': 'H3',
  'error': 'ERROR',
  'normal': 'NORMAL',
  'label': 'LABEL',
};

export default TEXT_STYLE_MAP;
